import { render, staticRenderFns } from "./VersionsView.vue?vue&type=template&id=a3f09828&scoped=true&"
import script from "./VersionsView.vue?vue&type=script&lang=js&"
export * from "./VersionsView.vue?vue&type=script&lang=js&"
import style0 from "./VersionsView.vue?vue&type=style&index=0&id=a3f09828&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f09828",
  null
  
)

export default component.exports